<template>
  <div class="index">
    <div class="phone" v-show="!isPc">
      <img src="../assets/phone1.png" @click="to('submit')">
      <img src="../assets/phone2.png" @click="to('search')">
      <img class="bg" src="../assets/phonebg.png">
    </div>
    <div class="pc" v-show="isPc">
      <img src="../assets/pc1.png" class="mr" @click="to('submit')">
      <img src="../assets/pc2.png" @click="to('search')">
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data(){
    return{
      isPc:false
    }
  },
  methods:{
    to(path){
      this.$router.push(path);
    }
  },
  mounted(){
    this.isPc = window.innerWidth>640?true:false;
    // console.log(this.isPc)
    
    // this.$notify({title: '提示',
    //       // message: '试运行已经结束,即将在12月5日切换到正式地址 http://221.224.13.15:8000/huanbao/pc/#/',
    //       message: '系统目前还在试运行中,地址为: http://218.4.111.162:6060/huanbao/phone/#/',
		// 			duration: 0,
    //       // position: 'top-right',
    //       // customClass:'notice',
    //       type:'warning',
		// 			showClose:true})
  }
}
</script>
<style scoped>
.phone{
  position: relative;
  height: 76vh;
  padding: 12vh 5vw;
}
.phone img{
  width: 90%;
  height: 14vh;
  margin-top: 5vh;
}
.phone img.bg{
  position: absolute;
  bottom: 2vh;
  left: 5%;
}
.pc{
  width: 60vw;
  height: 50vh;
  margin: 17vh 20vw;
}
.pc img{
  width: 25%;
}
img.mr{
  margin-right: 12%;
}
</style>